import httpism from 'httpism/browser.js'
import jsonReviver from '@booking-services/json-reviver'
import longResponseMiddleware from './../../../packages/middlewares/clientMiddleware.js'

function mockXhrMiddleware (req, next) {
  return next()
}

export default function ({webUrl = '/', additionalMiddleware = []}) {
  return httpism.client(
    webUrl + 'api/',
    {
      jsonReviver: jsonReviver,
      headers: {
        'Cache-Control': 'no-cache',
      },
    },
    [mockXhrMiddleware, longResponseMiddleware, ...additionalMiddleware]
  )
}
